import { FieldValue, Timestamp } from "firebase/firestore";
import { NewVisitControl, PutVisitControl } from "../../domain/control/Visit";
import { undefinedToNull } from "../../util/object";
import { formatDateAsTime } from "../../util/date";
import { isNil } from "lodash";

export type GetVisitControlDto = {
  approvedBy?: string;
  departure?: string;
  derivation?: string;
  dni?: number;
  entry?: string;
  lastname?: string;
  name?: string;
  observation?: string;
  ownerUid: string;
  phoneNumber?: string;
  subject?: string;
  timestamp: Timestamp;
  unityId?: number | string;
};

export type PostVisitControlDto = {
  ownerUid: string;
  unityId: number;
  entry: string;
  departure?: string;
  derivation?: string;
  dni?: string;
  observation?: string;
  timestamp: FieldValue;
  name?: string;
  lastname?: string;
  phoneNumber?: string;
  subject?: string;
  approvedBy?: string;
};

export type PutVisitControlDto = {
  departure?: string | null;
  observation?: string | null;
};

export const newVisitControlAsDto: (
  c: NewVisitControl
) => Partial<PostVisitControlDto> = (newControl) =>
  undefinedToNull({
    ...newControl,
    timestamp: Timestamp.now(),
    entry: formatDateAsTime(newControl.entry),
    departure: !isNil(newControl.departure)
      ? formatDateAsTime(newControl.departure)
      : null,
  });

export const putVisitControlAsDto: (
  c: PutVisitControl
) => Partial<PutVisitControlDto> = (putControl) =>
  undefinedToNull({
    ...putControl,
    departure: !isNil(putControl.departure)
      ? formatDateAsTime(putControl.departure)
      : null,
  });
